import type {VehicleDataDecimal} from './VehicleDataDecimal';

export type ElectricVehicleBattery = {
  /**
   * kWh, maximum power consumption of the on-board charger.
   */
  chargingAC: VehicleDataDecimal | null;
  /**
   * kWh, maximum power consumption on the fast DC charging stations
   */
  chargingDC: VehicleDataDecimal | null;
  /**
   * Battery capacity Wh
   */
  batteryCapacityWh: VehicleDataDecimal | null;
  /**
   * Battery capacity Ah
   */
  batteryCapacityAh: VehicleDataDecimal | null;
  /**
   * Battery Voltage V
   */
  batteryVoltage: VehicleDataDecimal | null;
};
